function cleanHeader(header) {
  return header.replace(/^\uFEFF/, "").trim(); // Remove BOM if present and trim whitespace/control chars
}

/**
 * Split a CSV line, respecting double-quoted fields (needed for Site Address commas).
 * @param {string} line
 * @returns {string[]}
 */
function parseCsvLine(line) {
  const values = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === "," && !inQuotes) {
      values.push(current.trim());
      current = "";
      continue;
    }

    current += char;
  }

  values.push(current.trim());
  return values;
}

export const parseCSV = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const csvData = event.target.result;
      const lines = String(csvData).split(/\r?\n/);

      const headers = parseCsvLine(lines[0]).map(cleanHeader);

      const results = [];
      for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue; // Skip empty lines

        const values = parseCsvLine(lines[i]);
        const row = {};

        headers.forEach((header, index) => {
          const cleanedHeader = header.trim();
          row[cleanedHeader] = values[index] ? values[index].trim() : "";
        });
        results.push(row);
      }
      resolve({ headers, results });
    };

    reader.onerror = (error) => {
      console.error(`Error reading CSV file: ${error}`);
      reject(error);
    };
    reader.readAsText(file);
  });
};
